import {Vector3} from 'three'

import {CORNER_RADIUS} from '../../modules/cube/_config'
import type {LayoutConfig} from '../../modules/cube/_types'

const basePosition = new Vector3(0.0, -1, 0.0)

const calcPosition = (pos: Vector3) => {
  pos.add(basePosition)
  pos.x *= 1.0 + CORNER_RADIUS * 1.1
  pos.y *= 1.0 + CORNER_RADIUS * 1.1
  pos.z *= 1.0 + CORNER_RADIUS * 1.1

  return pos
}

const offsetStart = {
  position: new Vector3(0, -3, 0),
  rotation: new Vector3(0, 0, 0),
}

const commonCubeConfig = {
  offsetStart,
  delay: 0.0,
  duration: 1,
  scale: 1,
}

const cubes = [
  // left
  {
    position: calcPosition(new Vector3(-3, -1, 5)),
    rotation: new Vector3(0, Math.PI * 0.5, 0.0),
    cubeType: 'glassNoBlur',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: false,
      },
    },
  },
  {
    position: calcPosition(new Vector3(-3, 0.0, 4)),
    rotation: new Vector3(0, 0, 0.0),
    cubeType: 'mosaic',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(1.0, 0, -2),
        visible: true,
      },
    },
  },
  {
    position: calcPosition(new Vector3(-2, -1, 4)),
    rotation: new Vector3(0, 0, 0.0),
    cubeType: 'glassNoBlur',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: false,
      },
    },
  },
  {
    position: calcPosition(new Vector3(-3, 0.0, 2)),
    rotation: new Vector3(0, Math.PI * 0.5, 0.0),
    cubeType: 'glassMosaic',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: false,
      },
    },
  },

  // center
  {
    position: calcPosition(new Vector3(-1.2, 0.0, 0)),
    rotation: new Vector3(0, 0, 0.0),
    cubeType: 'normal',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
    },
  },
  {
    position: calcPosition(new Vector3(0.0, 0.0, 0.0)),
    rotation: new Vector3(0, 0, 0.0),
    cubeType: 'whiteGreen',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
    },
  },

  // right
  {
    position: calcPosition(new Vector3(3.0, 0.0, -3.0)),
    rotation: new Vector3(0, 0, 0.0),
    cubeType: 'glassNoBlur',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: false,
      },
    },
  },
  {
    position: calcPosition(new Vector3(4.0, 0.0, -3.0)),
    rotation: new Vector3(0, 0, 0.0),
    cubeType: 'mosaic',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: false,
      },
    },
  },
  {
    position: calcPosition(new Vector3(5.0, -1.2, -3.0)),
    rotation: new Vector3(0, Math.PI, Math.PI * 0.5),
    cubeType: 'glassNoBlur',
    isGlassRender: false,
    ...commonCubeConfig,
    layout: {
      tablet: {
        offset: new Vector3(0, 0, 0),
        visible: true,
      },
      mobile: {
        offset: new Vector3(0, 0, 0),
        visible: false,
      },
    },
  },
]

const valley = (x: number) => {
  return Math.abs(2 * x - 1)
}

// cubes.forEach((cube, index) => {
//   cube.delay = index * 0.05;
//   cube.duration = 1.0;
// })

cubes.forEach((cube, index) => {
  const p = index / (cubes.length - 1)
  cube.delay = (1.0 - valley(p)) * 0.5
  cube.duration = 1.0
})

export default {
  rotation: new Vector3(-Math.PI * 0.2, -Math.PI * 0.25, 0),
  rotationOrder: 'XYZ',
  groupAnim: {
    start: new Vector3(0, -1, 0),
    end: new Vector3(0, 0, 0),
    duration: 4.0,
    ease: 'expo.out',
  },
  cubes,
} as LayoutConfig
